import PropTypes from 'prop-types';
import React from 'react';

require("./Cloth.scss");

/*
  NB: Numbers are sent from the API and tied to specific styles.
  If dog is not running, override number with 'nr' to get disabled effect
*/

export default function Cloth (props) {
  const {
    number
  } = props;

  return (
    <div className={`cloth-${number}`}>
      {number}
    </div>
  );
}

Cloth.propTypes = {
  number: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
}

Cloth.defaultProps = {
  number : 'nr'
}



// WEBPACK FOOTER //
// ./modules/Common/components/Cloth.js